module.exports = __webpack_public_path__ + "public/Icons/loginArrowIcon.svg?c906455b";